// JUNTA, SEGUNDA TANDA (Diego, 13-oct, 17:30): «que pueda SELECCIONAR a la persona para que en automático salgan sus
// datos». Diego, Miguel y Juan Carlos eligen a nombre de qué vendedor sale la cotización (p. ej. Juan Carlos le cotiza a
// Fernando Camou, externo de viaje). Buscador + lista nativa: en el celular la lista abre la rueda del sistema, y con
// muchos usuarios se escribe un pedazo del nombre. Quien la captura queda como «hecha por» (nunca en el PDF).
import { useState } from 'react';
import { puedeAutorizarDescuento } from '@cotizador/compartido';
import type { Usuario } from '@cotizador/compartido';
import { CampoSelect, CampoTexto } from './ui.tsx';

const sinAcentos = (s: string) => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

/** Usuarios que pueden llevar una cotización (activos y que no son técnicos), más el vendedor actual aunque ya no lo sea. */
export function vendedoresElegibles(usuarios: readonly Usuario[], actualId?: string): Usuario[] {
  return usuarios.filter((u) => (u.activo && u.rol !== 'tecnico') || u.id === actualId);
}

/** ¿Este usuario (con sus datos completos de la lista de usuarios) cotiza a nombre de otros? Misma regla que el servidor. */
export function cotizaANombreDeOtros(usuarios: readonly Usuario[], yoId: string): boolean {
  const yo = usuarios.find((u) => u.id === yoId);
  return Boolean(yo && puedeAutorizarDescuento(yo));
}

const etiquetaDe = (u: Usuario, yoId: string) =>
  `${u.nombre}${u.id === yoId ? ' (yo)' : ''}${u.rol === 'externo' ? ' · externo' : ''}${u.optimus ? ' · Optimus' : ''}${u.activo ? '' : ' · dado de baja'}`;

export function SelectorVendedor({
  usuarios,
  valor,
  alCambiar,
  yoId,
  etiqueta = 'A nombre de (vendedor)',
  ayuda,
  disabled,
}: {
  usuarios: readonly Usuario[];
  valor: string;
  alCambiar: (id: string) => void;
  yoId: string;
  etiqueta?: string;
  ayuda?: string;
  disabled?: boolean;
}) {
  const [busca, setBusca] = useState('');
  const lista = vendedoresElegibles(usuarios, valor);
  const b = sinAcentos(busca.trim());
  // El elegido siempre queda en la lista (si no, la lista nativa mostraría otro nombre del que está guardado).
  const filtrados = b ? lista.filter((u) => u.id === valor || sinAcentos(`${u.nombre} ${u.correo}`).includes(b)) : lista;
  return (
    <div className="pila">
      {lista.length > 6 && (
        <CampoTexto etiqueta="Buscar vendedor" type="search" placeholder="Escribe parte del nombre" value={busca} disabled={disabled} onChange={(e) => setBusca(e.target.value)} />
      )}
      <CampoSelect
        etiqueta={etiqueta}
        value={valor}
        disabled={disabled}
        onChange={(e) => alCambiar(e.target.value)}
        opciones={filtrados.map((u) => ({ valor: u.id, texto: etiquetaDe(u, yoId) }))}
        ayuda={ayuda ?? 'Sus datos salen en el PDF (tarjeta, foto y WhatsApp) y la cotización queda en su CRM. Tú quedas como «hecha por»; eso no sale en el PDF.'}
      />
    </div>
  );
}
